<template>
  <div class='contentBox'>
    <div class="titleText">热门城市</div>
    <div class="flex" style="flex-wrap:wrap">
        <div  class="label">
            <el-button plain @click="getInfo(info)">全国</el-button>
        </div>
        <div v-for="(item,index) in CityList.hot" :key="index" class="label">
            <el-button plain @click="getInfo(item)">{{item.title||''}}</el-button>
        </div>
    </div>
    <div v-for="(item,index) in CityList.list" :key="index">
        <div class="titleText">{{index}}</div>
        <div class="flex" style="flex-wrap:wrap">
             <div v-for="(info,key) in item" :key="key" class="label">
                <el-button plain  @click="getInfo(info)">{{info.title||''}}</el-button>
             </div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
name:'',
  components: {},
    data() {
      return {
        CityList:[],
        info:{
            id:0,
            title:"全国"
        }
      };
    },
  computed: {},
  watch: {},
  methods: {
        getCityIndex() {
            this.$api.index.CityIndex().then(res => {
                if (res.code == 200) {
                    this.CityList = res.data
                }
            })
        },
        getInfo(item){
            this.$emit('changeCity',item)
        },
  },
  created() {

  },
  mounted() {
    this.getCityIndex()
  }, 
}
</script>
<style lang='scss' scoped>
.contentBox{
    height: 50vh;
    overflow: auto;
    background: transparent !important;
    margin-top: 0 !important;
}
// .label{
//     margin: 0 5px;
// }

.el-button{
    margin:  5px;
}
::v-deep .el-dialog__body{
    padding: 0px 20px !important;
}
::v-deep .el-dialog__wrapper{
  
}
.titleText{
    margin: 10px 0;
}


</style>